/**
 * Version stamp for FE-optimistic goal seeds (drag-drop pair, XD chain).
 *
 * Deliberately NOT `"0"`: `"0"` is the API-seed default, and the seed-path gate
 * (`shouldAcceptApiSeed`) treats `"0"`-over-`"0"` as acceptable. A real operator
 * mutation sitting at `"0"` would therefore be silently reverted by the next
 * refetch.
 *
 * Unparseable by `parseVersionKey` exactly like `"0"`, so arbitration against any
 * REAL version is byte-identical — an optimistic seed still loses to any real WS
 * push, and still loses to `applyGoalFromMutation`'s 19-digit stamp. What changes
 * is that it now BEATS a stale `"0"` API seed, and that a slice entity sitting at
 * `"0"` can be overwritten by it (which is what makes the XD chain's optimistic
 * update branches land at all — at `"0"` they were dead).
 *
 * Truth table:
 * `.claude/specs/ryte-three-layer-pipeline/chunks/chunk-06-api-seed-overwrite.md`
 *
 * Lives in its own module rather than as a `ryteDataSlice` export because both
 * optimistic-hook specs mock that slice wholesale with a factory exporting only
 * action creators. A constant exported from the slice would resolve to `undefined`
 * in the hook AND in the spec, so every `toBe(OPTIMISTIC_SEED_VERSION)` assertion
 * would pass vacuously while production stamped `undefined`.
 *
 * Matches the repo's `~`-prefix convention for FE-synthesized values (`~temp:`),
 * and can never collide with a numeric wire version.
 */
export const OPTIMISTIC_SEED_VERSION = "~optimistic";
